import { Source } from 'react-native-fast-image';
import { registerImages } from '@betty/moonlight';
import images from './images';

registerImages('rewards', images);

declare global {
  interface RegisteredImages {
    rewards: Record<keyof typeof images, Source>;
  }
}
